import styled from '@emotion/styled';
import { Text } from './../text';

export const ErrorText = styled(Text)(({ theme }) => ({
    color: theme.colors.secondaryRed,
}));
